import { AdjustVehicleGroupsCtrl }  from './vehicle-groups.adjust-vehicle-groups';
import { BodyTypesByGroupCtrl}      from './vehicle-groups.body-types-by-group';
import { ManageVehicleTypesCtrl }   from './vehicle-types.manage.ajs';
import { NewBodyTypeCtrl }          from './vehicle-groups.new-body-type';
import { NewVehicleGroupCtrl }      from './vehicle-groups.new-vehicle-group';
import { VehicleBodyTypesCtrl }     from './vehicle.body-types.ajs';
import { VehicleGroupsCtrl }        from './vehicle-groups';
import { VehicleGroupsStates }      from './vehicle-groups.states.ajs';

angular.module('workshop.vehicles.groups', [])

.controller('AdjustVehicleGroupsCtrl', AdjustVehicleGroupsCtrl)
.controller('bodyTypesByGroupCtrl',    BodyTypesByGroupCtrl)
.controller('ManageVehicleTypesCtrl',  ManageVehicleTypesCtrl)
.controller('newBodyTypeCtrl',         NewBodyTypeCtrl)
.controller('newVehicleGroupCtrl',     NewVehicleGroupCtrl)
.controller('VehicleBodyTypesCtrl',    VehicleBodyTypesCtrl)
.controller('vehicleGroupsCtrl',       VehicleGroupsCtrl)

.config(VehicleGroupsStates);